import { useMutation, useQueryClient } from '@tanstack/react-query'
import MilkingProcessService from 'services/milkingProcessService'
import { useAppDispatch } from 'store/hooks'
import { notifyUser } from 'store/notificationsSlice'

export const useUpdateMilkerMutation = () => {
	const queryClient = useQueryClient()
	const dispatch = useAppDispatch()

	return useMutation({
		mutationFn: ({
			id,
			fullName,
			photo,
		}: {
			id: number | string
			fullName: string
			photo?: File | null
		}) => MilkingProcessService.updateMilker(id, fullName, photo),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['milkers-info'] })
			dispatch(
				notifyUser({
					title: 'Данные успешно сохранены',
					description: '',
					isError: false,
				}),
			)
		},
		onError: () => {
			dispatch(
				notifyUser({
					title: 'Произошла ошибка',
					description: 'Попробуйте снова.',
					isError: true,
				}),
			)
		},
	})
}
